import { render, staticRenderFns } from "./printOrderDetail.vue?vue&type=template&id=47a9aab8&scoped=true&"
import script from "./printOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./printOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./printOrderDetail.vue?vue&type=style&index=0&id=47a9aab8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a9aab8",
  null
  
)

export default component.exports